import { Component, ElementRef, inject, OnDestroy, OnInit, TemplateRef, ViewChild, NgZone, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute, Router, RouterLink, RouterOutlet } from '@angular/router';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ConfirmationModalComponent } from '../confirmation-modal/confirmation-modal.component';
import { localStorageService } from '../localstorage.service';
import { MainService } from '../main.service';
import { countryType, SharedService, timezoneType } from '../shared.service';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { ApiService } from '../api.service';
import { Subscription } from 'rxjs';
import { SocketsService } from '../socket.service';
import moment from 'moment';
import { SalesViewService } from '../../pages/sales/sales-view.service';
import { ToasterService } from '../toaster/toaster.service';
import { PermissionsService } from '../permissions/permissions.service';
import { BsDropdownDirective, BsDropdownToggleDirective, BsDropdownMenuDirective } from 'ngx-bootstrap/dropdown';
import { SalesHeaderComponent } from '../../pages/sales/sales-header/sales-header.component';
import { NgClass, DatePipe } from '@angular/common';
import { NavsearchComponent } from './navsearch/navsearch.component';
import { IncomingCallComponent } from '../incoming-calls/incoming-calls.component';
import { ActiveCallWidgetComponent } from '../active-call-widget/active-call-widget.component';
import { PasswordExpiryReminderComponent } from '../password-expiry-reminder/password-expiry-reminder.component';

// Shown for each ?gmail=error&reason=... the backend's
// /auth/google/callback redirect can send back. Source: Google Mail Sync
// Developer Guide (https://microservicedocs.denefits.com/google-mail-sync-guide#frontend).
const GMAIL_ERROR_MESSAGES: { [reason: string]: string } = {
  missing_code: 'Gmail connection was cancelled.',
  invalid_state: 'The connection link expired. Please try again.',
  no_refresh_token: 'Remove this app from your Google account permissions, then connect again.',
  connect_failed: 'Could not connect Gmail. Please try again.',
  unknown: 'Could not connect Gmail. Please try again.',
};

@Component({
    selector: 'app-main-layout',
    templateUrl: './main-layout.component.html',
    styleUrls: ['./main-layout.component.scss'],
    animations: [
        trigger('drawerState', [
            state('open', style({ transform: 'translateX(0%)' })), // Visible
            state('closed', style({ transform: 'translateX(100%)' })), // Hidden
            transition('open <=> closed', animate('300ms ease-in-out'))
        ]),
        trigger('salesDrawerState', [
            state('open', style({ transform: 'translateX(0%)' })), // Visible
            state('closed', style({ transform: 'translateX(100%)' })), // Hidden
            transition('open <=> closed', animate('300ms ease-in-out'))
        ])
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [BsDropdownDirective, BsDropdownToggleDirective, BsDropdownMenuDirective, RouterLink, SalesHeaderComponent, NgClass, NavsearchComponent, RouterOutlet, IncomingCallComponent, ActiveCallWidgetComponent, DatePipe, PasswordExpiryReminderComponent]
})
export class MainLayoutComponent implements OnInit, OnDestroy {
  menuList: any = [];
  timezoneList: any = [];
  selectedTimezone: any;

  isCollapsed = true;
  isSalesDrawerOpen = false;
  salesActiveTab = 'emails';
  commCenterMappedFilter: 'all' | 'mapped' | 'unmapped' = 'all';
  notifications: Notification[] = [];
  unread_count: number = 0;
  count: number = 0;
  // Sales roles with canSeeNotifications paginate the drawer (10 per page);
  // other roles get a fixed 5 and use the "View All" page instead.
  get notificationPageSize(): number {
    return this._permissions.salesPermissionFlags.canSeeNotifications ? 10 : 5;
  }
  // Offset of the first in-memory notification (windowed paging).
  notificationWindowStart = 0;
  // Max pages kept in memory; older/newer pages are dropped and re-fetched on scroll.
  readonly notificationMaxWindowPages = 3;
  limit = 10;
  currentTime = new Date();
  offset = 0;
  isLoading: boolean = false;
  countryList: any = [];
  selectedCountry: any;

  isDummy = true;
  communicationNotificationCount = 0;

  searchNavBarShow = false;
  admin_profile: any;
  private _users: any;
  role: any ;
  paramSubscription: any;
  filterTimezones: any = [];
  timezones: any = [];
  country_id:any;
  timezone: any;
  timezoneName: any = '';
  timezoneTime: any;
  notification_count = 0;
  is_manager = false;
  notificationCount = 0;
  /**
   * Cap-driven Team-Lead flag used by the upcoming-task timer link in the
   * header. Replaces the inline `['Team_lead_l1','Team_lead_l2'].includes(admin_profile.role_enum)`
   * check that previously decided whether to forward `assigned_to` as the
   * deep-link `admin_id` query param.
   */
  get isTeamLead(): boolean {
    return this._permissions.isTeamLead;
  }

  selectedSubMenu:any;
  selectedParentMenu: any;
  modalRef!: BsModalRef;
  gmailConnectModalRef!: BsModalRef;
  gmailConnected: boolean = false;
  gmailConnectedEmail: string = '';
  // True from the moment the popup opens until applyGmailAuthResult runs
  // (success or failure) -- shows a spinner on "Continue with Google" for
  // that whole window, since the popup itself can take a while (admin
  // picking an account, Google's consent screen, the backfill starting).
  gmailConnecting: boolean = false;
  // Set once applyGmailAuthResult has actually run for the current popup,
  // so watchGmailAuthPopup's closed-popup fallback never overrides a
  // result that already landed -- see watchGmailAuthPopup below.
  private gmailAuthResultApplied: boolean = false;
  // Reference to the open popup, so applyGmailAuthResult can force-close it
  // the instant a result lands instead of waiting on the popup's own
  // window.close() -- see applyGmailAuthResult below.
  private gmailAuthPopup: Window | null = null;
  private sub = new Subscription();
  latestTask: any;
  taskCountdown: string = '';
  taskInterval: any;
  remainingMs: number = 0;
  @ViewChild('loginAuthentication') restricted!: TemplateRef<any>;
  @ViewChild('connectGmailModal') connectGmailModal!: TemplateRef<any>;
  @ViewChild('notificationList') notificationListRef?: ElementRef<HTMLElement>;
  isSalesRoute = false;
  private salesView = inject(SalesViewService)
  communication_data: any;
  filteredCommunicationLogs: any[] = [];
  callNotificationCount: any = 0;
  smsNotificationCount: any = 0;
  emailNotificationCount: any = 0;
  mappedCallNotificationCount: any = 0;
  unmappedCallNotificationCount: any = 0;
  mappedSmsNotificationCount: any = 0;
  unmappedSmsNotificationCount: any = 0;
  mappedEmailNotificationCount: any = 0;
  unmappedEmailNotificationCount: any = 0;
  activeCommAlerts: any[] = [];

  // Hardware state
  hasMicrophone = false;
  hasAudioOutput = false;
  micDeviceName = ''; 
  audioDeviceName = ''; 
  micPermission: PermissionState | 'unknown' = 'unknown';
  showPermissionBanner = false;
  showDevicePanel = false;
  private deviceToastInterval: any;
  private devicePollInterval: any;   // 5s poll so pills update in real-time
  private deviceChangeHandler = () => this.detectDevices();
  private ngZone = inject(NgZone);
  private _toaster = inject(ToasterService);
  private _permissions = inject(PermissionsService);
  profileData: any;

  constructor(private _router: Router,private modalService: BsModalService,private _local : localStorageService, private _main: MainService, public _shared: SharedService, private route: ActivatedRoute, private _api:ApiService, public router: Router,public _socket: SocketsService,) {}

  /** Enumerate connected media devices, update flags and device labels. */
  private async detectDevices(): Promise<void> {
    try {
      const prevMic = this.hasMicrophone;
      const prevAudio = this.hasAudioOutput;
      this.profileData = this._local.customGetItem('admin_profile');
      // Manager detection flows from PermissionsService — capability-driven
      // (VIEW_ALL or wildcard / super-admin).
      this.is_manager = this._permissions.isManager;
      if (!navigator.mediaDevices || !navigator.mediaDevices.enumerateDevices) {
        console.warn('Media Devices API not supported');
        return;
      }
      const devices = await navigator.mediaDevices.enumerateDevices();
      this.ngZone.run(() => {
        const mic = devices.find(d => d.kind === 'audioinput');
        const speaker = devices.find(d => d.kind === 'audiooutput');
        this.hasMicrophone = !!mic;
        this.hasAudioOutput = !!speaker;
        this.micDeviceName = mic?.label || (mic ? 'Microphone' : '');
        this.audioDeviceName = speaker?.label || (speaker ? 'Speaker / Headphone' : '');

        // Instant toast when a device is removed while on sales route
        if (this.isSalesRoute && !this.is_manager) {
          const lost: string[] = [];
          if (prevMic && !this.hasMicrophone) lost.push('Microphone');
          if (prevAudio && !this.hasAudioOutput) lost.push('Speaker / Headphone');
          if (lost.length) {
            this._toaster.showToaster(
              'Device Disconnected',
              `${lost.join(' & ')} was disconnected. Please reconnect to continue calls.`,
              'warning'
            );
          }
        }
      });
    } catch (err) {
      console.warn('Device enumeration failed', err);
    }
  }

  /** Check browser permission status for microphone only. */
  private async checkPermissions(): Promise<void> {
    try {
      if (navigator.permissions) {
        const micStatus = await navigator.permissions.query({ name: 'microphone' as PermissionName });
        this.micPermission = micStatus.state;
        micStatus.onchange = () => this.ngZone.run(() => {
          this.micPermission = micStatus.state;
          this.evaluatePermissionBanner();
          this.detectDevices();
        });
      }
    } catch (err) {
      console.warn('Permissions API not available', err);
    }
    this.evaluatePermissionBanner();
  }

  /** Show the banner if microphone permission is denied. */
  private evaluatePermissionBanner(): void {
    this.showPermissionBanner = this.isSalesRoute && !this.is_manager && this.micPermission === 'denied';
  }

  /** User clicks "Allow" → trigger the browser permission prompt. */
  requestPermissions(): void {
    navigator.mediaDevices.getUserMedia({ audio: true, video: false })
      .then(stream => {
        stream.getTracks().forEach(t => t.stop());
        this.micPermission = 'granted';
        this.evaluatePermissionBanner();
        this.detectDevices();
      })
      .catch(() => {
        this.micPermission = 'denied';
        this.evaluatePermissionBanner();
      });
  }

  toggleDevicePanel(): void {
    this.showDevicePanel = !this.showDevicePanel;
    if (this.showDevicePanel) {
      this.detectDevices();
    }
  }

  dismissPermissionBanner(): void {
    this.showPermissionBanner = false;
  }

  // ─── Device polling + toast loop ───────────────────────────────
  private startDeviceToastLoop(): void {
    this.stopDeviceToastLoop();

    // Poll devices every 5 s so pills update even if devicechange event doesn’t fire
    this.devicePollInterval = setInterval(() => this.detectDevices(), 5_000);

    // Toast: fire once now, then every 60 s
    this.showDeviceToastIfNeeded();
    this.deviceToastInterval = setInterval(() => this.showDeviceToastIfNeeded(), 60_000);
  }

  private stopDeviceToastLoop(): void {
    if (this.deviceToastInterval) {
      clearInterval(this.deviceToastInterval);
      this.deviceToastInterval = null;
    }
    if (this.devicePollInterval) {
      clearInterval(this.devicePollInterval);
      this.devicePollInterval = null;
    }
  }

  /** Re-detect, then toast if something is still missing. */
  private async showDeviceToastIfNeeded(): Promise<void> {
    if (!this.isSalesRoute) return;
    if(this.is_manager) return;
    await this.detectDevices();           // refresh flags first
    const missing: string[] = [];
    if (!this.hasMicrophone) missing.push('Microphone');
    if (!this.hasAudioOutput) missing.push('Speaker / Headphone');
    if (missing.length) {
      this._toaster.showToaster(
        'Device Not Connected',
        `${missing.join(' & ')} not detected. Please connect to continue calls.`,
        'warning'
      );
    }
  }

  ngOnInit() {
    window.addEventListener('storage', this.handleGmailAuthStorageEvent);

    // ── Hardware device & permission checks (run once; toast loop gated by sales route) ──
    this.detectDevices();
    this.checkPermissions();
    if (navigator.mediaDevices?.addEventListener) {
      navigator.mediaDevices.addEventListener('devicechange', this.deviceChangeHandler);
    }

    this.updateSalesRoute(this.router.url);
    this.sub.add(this.router.events.subscribe(() => this.updateSalesRoute(this.router.url)));

    this._socket.on('new_notification', (data: any) => {
      this.notification_count = this.notification_count + 1;

      if (data.data) {
        // Windowed paging: if the user has scrolled past the first page, the
        // in-memory list no longer starts at offset 0 — prepending here would
        // corrupt the window offsets. Shift the window instead; the new items
        // are fetched when the user scrolls back to the top.
        if (this.notificationWindowStart > 0) {
          const arrivedCount = Array.isArray(data.data) ? data.data.length : 1;
          this.notificationWindowStart += arrivedCount;
          this.count += arrivedCount;
          return;
        }

        if (Array.isArray(data.data)) {
          // Multiple notifications — each item carries its own metadata, so
          // decorateNotifications handles type-50 decoration per item.
          const decorated = this.decorateNotifications(data.data);
          this.notifications =
            decorated.length > 10 ? decorated.slice(0, 10) : [...decorated, ...this.notifications];
        } else if (data.data.notification_type == 50) {
          // Single notification — metadata arrives as a sibling key; attach it so it
          // matches the fetch shape decorateNotifications/redirectToNotification expect.
          const parsed_notification = { ...data.data, metadata: data.data.metadata ?? data.metadata };
          const [decorated] = this.decorateNotifications([parsed_notification]);
          if (decorated) this.notifications.unshift(decorated);
        } else {
          this.notifications.unshift(data.data);
        }
        this.count += Array.isArray(data.data) ? data.data.length : 1;
      }

    })
    this._socket.on('LEAD_CSV_UPLOAD_COMPLETE', (data: any) => {
      if (!data) return;
      if (data.admin_id && data.admin_id !== this.admin_profile?.admin_id) return;
      const { total_count, success_count, failed_count } = data;
      let description = `Lead upload complete: ${success_count} of ${total_count} leads imported successfully.`;
      if (failed_count > 0) {
        description += ` ${failed_count} lead(s) failed — check your email for details.`;
      }
      this._toaster.showToaster(
        'Lead Upload Complete',
        description,
        failed_count > 0 ? 'warning' : 'success'
      );
    });

    this._socket.on('CommunicationCenterAlert', (data: any) => {
      if (data) {
        this.communicationNotificationCount = this.communicationNotificationCount + 1;
        if (data.type === 'call') {
          this.callNotificationCount = this.callNotificationCount + 1;
          if (data.lead_id) {
            this.mappedCallNotificationCount = this.mappedCallNotificationCount + 1;
          } else {
            this.unmappedCallNotificationCount = this.unmappedCallNotificationCount + 1;
          }
        } else if (data.type === 'sms') {
          this.smsNotificationCount = this.smsNotificationCount + 1;
          if (data.lead_id) {
            this.mappedSmsNotificationCount = this.mappedSmsNotificationCount + 1;
          } else {
            this.unmappedSmsNotificationCount = this.unmappedSmsNotificationCount + 1;
          }
        } else if (data.type === 'EMAIL') {
          this.emailNotificationCount = this.emailNotificationCount + 1;
          if (data.lead_id) {
            this.mappedEmailNotificationCount = this.mappedEmailNotificationCount + 1;
          } else {
            this.unmappedEmailNotificationCount = this.unmappedEmailNotificationCount + 1;
          }
        }
        
        // Push notification logic
        const alert = {
          ...data,
          id: Date.now() + Math.random(),
        };
        this.activeCommAlerts.push(alert);
        
        setTimeout(() => {
          this.removeCommAlert(alert.id);
        }, 5000);
      }
    });

    this.admin_profile = this._local.customGetItem('admin_profile');
    this._shared.adminProfileImage = this.admin_profile.admin_image
    // Capability refresh now happens in APP_INITIALIZER (see app.module.ts)
    // so the snapshot is populated BEFORE route guards run on a hard refresh.
    // The duplicate call that used to live here is intentionally gone.
    setInterval(() => {
      this.currentTime = new Date();
    }, 1000);
    this.getRoles();
    this._main.menu$.subscribe((allMenus: any) => {
      const menus = JSON.parse(JSON.stringify(allMenus));
      if (menus && menus.length) {
        this._shared.routerAuth.routeAuth(menus);
        this.menuList = menus;
        let all_menu: any = [];
        this.menuList.forEach((item: any) => {
          // if (item['only_path'] === '1') {
          //   main_menu.splice(index, 1);
          // }
          let submenu: any = [];
          if (item['submenu'] && item['submenu'].length > 0) {
            item['submenu'].forEach((sub: any) => {
              if (sub['only_path'] !== 1 && sub['only_path'] !== '1') {
                if (!submenu) {
                  submenu = [];
                }
                submenu.push(sub);
              }
            });
          }
          item.submenu = submenu;
          if (item['only_path'] !== 1 && item['only_path'] !== '1') {
            all_menu.push(item);
          }
        });

        all_menu.forEach((item: any) => {
          if (item.submenu) {
            item.submenu = item.submenu.sort((a: any, b: any) => {
              return a.in_order - b.in_order;
            });
            if (item.submenu.length === 0) {
              item.submenu = null;
            }
          }
        });
        this.menuList = all_menu;
      }
    })

    const queryParams = { ...this.route.snapshot.queryParams };
    this.isDummy = queryParams && queryParams['is_dummy'] == 1 ? true : false;
    console.log('this.isDummythis.isDummy', this.isDummy);
    this._main.country_data$.subscribe(counList => {
      this.countryList = counList;
      let item = counList.find((country: countryType) => country.country_id === (queryParams && Number(queryParams['country_id'])));
      item = item && item.country_id ? item : counList[0];
      if (item && item.country_id) {
        this.selectedCountry = item;
        this._shared.mask = item.country_phone_format;
      }
      this.updateQueryParams();
    })

    this._main.timezoneList$.subscribe(tZList => {
      if (tZList && tZList.length) {
        // static US country set
        this.timezoneList = tZList;
        // this.timezoneList = tZList.filter((item: any) => item.country_id === 1);
        let item = tZList.find((timezone: timezoneType) => timezone['val'] === ((queryParams && queryParams['timezone'] || '-800')));
        item = item && item.tz_id ? item : tZList[0];
        this.selectedTimezone = item;
        this._shared.timezone = item['val'];
        this._shared.allTimezoneData$.next(item);
        this._shared.timezoneName$.next(item['name']);
        this._shared.zone$.next(item['zone'] || item['offset'] || '');
        this.updateQueryParams();
        this.fetchLatesTask();
        // this._shared.timezoneName$.next(timeZ['name']);
        // this._shared.zone$.next(timeZ['zone']);
      }
    })

    this._shared.timezoneName$.subscribe(response => {
      if (response && response.length) {
        this.filterTimezones = []
        const data = this._shared.getTimezoneList();
        for (var i = 0; i < data.length; i++) {
          if (data[i].val) {
            var tzOffset = (parseInt(data[i].val.substring(0, data[i].val.length - 2)) * 60) + parseInt(data[i].val.substring(data[i].val.length - 2));
            var timezoneHours = parseInt((parseInt((tzOffset + "")) / 60) + "");
            timezoneHours = timezoneHours < 0 ? (-1 * timezoneHours) : timezoneHours;
            var timezoneMinutes = (tzOffset % 60);
            timezoneMinutes = timezoneMinutes < 0 ? (-1 * timezoneMinutes) : timezoneMinutes;
            var timezoneString = (tzOffset < 0 ? "-" : "+") + (timezoneHours < 10 ? "0" : "") + timezoneHours + ":" + (timezoneMinutes < 10 ? "0" : "") + timezoneMinutes;
            this.filterTimezones.push({
              code: data[i].offset,
              name: data[i].name,
              tzOffset: tzOffset,
              timezoneString: timezoneString,
              country_id: data[i].country_id,
              val: data[i].val,
              offset: data[i].offset,
              zone: data[i].zone,
            });
          }
          if (i === data.length - 1) {
            this.timezoneName = this.filterTimezones && this.filterTimezones.find((id: any) => id.val == this.timezone)?.code;
            console.log(this.timezoneName);
          }
        }
      }
    });
    this.paramSubscription = this.route.queryParams.subscribe((params) => {
      this.timezone = params['timezone'];
      this.country_id = params['country_id'];
    if (!(this.filterTimezones && this.filterTimezones.length)){
        this.filterTimezones = this.timezones;
      }
      if (this.filterTimezones.length && this.country_id) {
        this.filterTimezones = this.filterTimezones.filter(
          (el: any) => (el.country_id == this.country_id || el.country_id == 0)
        );
      }
      this.timezoneName = this.filterTimezones && this.filterTimezones.find((id: any) => id.val == this.timezone)?.offset;
    });

    this.sub = this._shared.notificationCount$.subscribe(count => {
      // Only refetch when the unread count INCREASED (new notifications from
      // another source). Decrements come from local mark-read actions that
      // already updated the list — refetching would reset the scroll window.
      if (count > this.notification_count) {
        this.getNotifications();
      }
      this.notification_count = count;
    });
    this.getNotifications();
    this._shared.callLatestTask.subscribe((res) => {
      if (res) {
        this.fetchLatesTask();
      }
    })
    // this._main.getTimezoneCountry().subscribe(([tZList, counList]) => {
    //   if (tZList && tZList.length){
    //     this.timezoneList = tZList;
    //     let item = tZList.find((timezone: timezoneType) => timezone['val'] === (queryParams && queryParams['timezone']));
    //     item = item && item.tz_id ? item : tZList[0];
    //     this.selectedTimezone = item;
    //     this._shared.timezoneName$.next(item['name']);
    //     // this._shared.zone$.next(timeZ['zone']);
    //   }

    //   this.countryList = counList;
    //   let item = counList.find((country: countryType) => country.country_id === (queryParams && Number(queryParams['country_id'])));
    //   item = item && item.cocu_id ? item : counList[0];
    //   if (item && item.cocu_id) {
    //     this.selectedCountry = item;
    //     this._shared.mask = item.country_phone_format;
    //   }
    //   this.updateQueryParams();
    // })
  }
  ngAfterViewInit(): void {
    const is_restricted = localStorage.getItem('is_restricted') === '1';

    if (!is_restricted && !this.modalRef?.id) {
      // Gmail-connect modal (if due) is deferred until this one is
      // acknowledged -- see proceedToLogin(). Showing both at once would
      // stack two BsModalRefs on top of each other.
      this.openModalRestrictedModal(this.restricted);
      this.disableInspect();
    } else {
      this.maybeShowGmailConnectModal();
    }
  }

  // show_gmail_connect_modal is set once per fresh login by
  // login.component.ts / new-password.component.ts, and consumed on read so
  // navigating between routes doesn't reopen it. Called after the
  // restricted-access modal (if any) is acknowledged, never alongside it.
  //
  // gmail_connected is a cached status flag ('1' / '0'), written once right
  // here after login and read on every later refresh instead of calling
  // /gmail/status again each time -- see checkGmailStatus().
  private maybeShowGmailConnectModal(): void {
    // Authoritative, checked first regardless of which branch below would
    // otherwise run: a super admin can flip is_gmail_sync_enable off for
    // this admin at any time via the RBAC Users list. The backend's own
    // /gmail/auth-url also re-checks this on every call (see
    // gmail.controller.js#getAuthUrl) and would reject it either way, but
    // the modal should never even appear for a disabled admin in the
    // first place.
    const admin_profile = this._local.customGetItem('admin_profile');
    if (!admin_profile || !admin_profile.is_gmail_sync_enable) {
      this._local.customSetItem('show_gmail_connect_modal', false);
      return;
    }

    if (this._local.customGetItem('show_gmail_connect_modal')) {
      this._local.customSetItem('show_gmail_connect_modal', false);
      this.checkGmailStatus();
      return;
    }

    if (this._local.customGetItem('gmail_connected') !== '1') {
      this.openConnectGmailModal();
    }
  }

  // Asks the backend whether this admin's Gmail is already connected
  // (GET /gmail/status, see gmail.controller.js#getStatus), caches the
  // answer, and only opens the modal when it isn't.
  private checkGmailStatus(): void {
    this._api.api({}, 'gmail/status', 'get').subscribe({
      next: (data: any) => {
        const connected = !!(data && !data.is_error && data.connected);
        this._local.customSetItem('gmail_connected', connected ? '1' : '0');
        if (connected) {
          this.gmailConnected = true;
          this.gmailConnectedEmail = data.email || '';
        } else {
          this.openConnectGmailModal();
        }
      },
      // Status check itself failed (network/server error, not "not
      // connected") -- fail safe by showing the modal rather than silently
      // skipping it.
      error: () => this.openConnectGmailModal(),
    });
  }

  // Handles the { status, email? | reason?, expected? } object
  // gmail-auth-result.component.ts (the popup) writes to localStorage,
  // read here via the storage event handler above.
  private applyGmailAuthResult(result: { status: string; email?: string; reason?: string; expected?: string }): void {
    this.gmailAuthResultApplied = true;
    this.gmailConnecting = false;

    // gmail-auth-result.component.ts writes its result to localStorage as
    // soon as its route resolves, THEN closes itself -- Angular bootstrap
    // and render inside the popup can lag behind that write by well over a
    // second on a slow load, so the storage event (and this handler) can
    // fire while the popup is still sitting on screen, blank, well after
    // the real connection is already done (decided 2026-10-15, matching
    // what was reported: button back to "Continue with Google", popup
    // still open and blank). Force-closing here instead of waiting on the
    // popup's own window.close() removes that stuck-looking gap entirely.
    if (this.gmailAuthPopup && !this.gmailAuthPopup.closed) {
      this.gmailAuthPopup.close();
    }
    this.gmailAuthPopup = null;
    if (result.status === 'connected') {
      // Done: the one case this modal is allowed to close on its own.
      this.gmailConnected = true;
      this.gmailConnectedEmail = result.email || '';
      this._local.customSetItem('gmail_connected', '1');
      this.closeConnectGmailModal();
      this._shared.customPopups(`Connected ${this.gmailConnectedEmail}`, 3);
    } else {
      // Failed: keep (or re-open) the modal so the admin can retry --
      // connecting Google is not optional.
      this.openConnectGmailModal();
      const reason = result.reason || 'unknown';
      const message = reason === 'email_mismatch' && result.expected
        ? `You need to login with ${result.expected}`
        : (GMAIL_ERROR_MESSAGES[reason] || GMAIL_ERROR_MESSAGES['unknown']);
      this._shared.customPopups(message, 1);
    }
  }

  openConnectGmailModal() {
    // Not dismissible: no backdrop click, no Escape key, no close button in
    // the template. The admin must connect Google to proceed.
    this.gmailConnectModalRef = this.modalService.show(this.connectGmailModal, {
      class: 'modal-dialog-centered',
      backdrop: 'static',
      keyboard: false,
      ignoreBackdropClick: true,
    });
    // Same inspect-blocking as the restricted-access modal (disableInspect
    // below), but WITHOUT that modal's className-overwrite trick -- that
    // hack replaces ngx-bootstrap's own classes on the dialog element and
    // is why its backdrop breaks after "I Acknowledge" is clicked. Plain
    // disableInspect()/enableInspect() carries none of that risk since it
    // only adds/removes document-level event listeners.
    this.disableInspect();
  }

  connectGmail() {
    this.gmailConnecting = true;

    // Opened synchronously, inside the click handler, on a blank page --
    // not after the /gmail/auth-url response (decided 2026-10-15). Browsers
    // only treat window.open() as part of a trusted user gesture while it's
    // still on the same call stack as the click; once it ran after an
    // await/subscribe boundary (as it did before), popup blockers silently
    // swallowed it on some browsers with no error and no null return --
    // nothing visibly happened. Opening blank here, then redirecting this
    // same window once the real URL comes back, keeps it inside the click.
    const popup = window.open('', 'gmail_auth', 'width=520,height=640');
    if (!popup) {
      this.gmailConnecting = false;
      this._shared.customPopups('Please allow pop-ups for this site to connect Gmail.', 1);
      return;
    }

    // window.location.origin is sent so the backend can route the popup's
    // callback redirect back to THIS tab's real origin instead of trusting
    // admin_panel_link (generalVariableSettings.js) to be correct for
    // whatever environment is live right now -- see
    // gmail.controller.js#getAuthUrl / googleOauthCallback.
    const returnOrigin = window.location.origin;
    this._api.api({ return_origin: returnOrigin }, 'gmail/auth-url', 'get').subscribe({
      next: (data: any) => {
        if (data && !data.is_error && data.url) {
          // Popup, not a main-tab navigation (decided 2026-10-14): Google's
          // consent screen can't be embedded in an in-page modal, so this is
          // the only way to keep the CRM session/page alive underneath while
          // the OAuth round-trip happens. The popup lands on
          // /gmail-auth-result (its own route, not this admin panel's normal
          // pages) and reports back via a storage event -- see
          // handleGmailAuthStorageEvent below and
          // gmail-auth-result.component.ts.
          popup.location.href = data.url;
          this.gmailAuthPopup = popup;
          this.watchGmailAuthPopup(popup);
        } else {
          popup.close();
          this.gmailConnecting = false;
          this._shared.customPopups(data?.err || 'Could not start Gmail connection.', 1);
        }
      },
      // ApiService.api() re-throws HTTP errors (403 from the
      // is_gmail_sync_enable gate, 500, network failure) rather than
      // folding them into the success-shaped payload above -- without this
      // handler the blank popup opened above was left stranded forever and
      // gmailConnecting never cleared, since `next` simply never ran.
      error: (err: any) => {
        popup.close();
        this.gmailConnecting = false;
        this._shared.customPopups(err?.error?.err || 'Could not start Gmail connection.', 1);
      },
    });
  }

  // Safety net for gmailConnecting: if the admin closes the popup manually
  // (or it closes for any reason) without ever writing a result -- e.g.
  // they just abandon the Google consent screen -- the storage event in
  // handleGmailAuthStorageEvent never fires, and without this the spinner
  // would spin forever. Polling is the only cross-origin-safe way to
  // detect this; `popup.closed` is readable even after Google's domain
  // navigated it away and back.
  //
  // gmail-auth-result.component.ts writes to localStorage, THEN closes
  // itself 50ms later -- so `popup.closed` can flip true slightly before
  // the storage event reaches this tab. Declaring "closed with no result"
  // right on that poll tick re-enabled the button for a brief window
  // (decided 2026-10-15): an admin clicking again then opened a second
  // popup while the first connect was still landing. The grace delay below
  // gives applyGmailAuthResult a chance to run first; gmailAuthResultApplied
  // then suppresses this fallback entirely once it has.
  private watchGmailAuthPopup(popup: Window): void {
    this.gmailAuthResultApplied = false;
    const poll = setInterval(() => {
      if (!popup.closed) {
        return;
      }
      clearInterval(poll);
      setTimeout(() => {
        if (this.gmailAuthResultApplied) {
          return;
        }
        this.ngZone.run(() => { this.gmailConnecting = false; });
      }, 1000);
    }, 500);
  }

  // Fired whenever ANY key changes in this origin's localStorage from
  // another window -- the browser never fires this in the window that made
  // the write, which is exactly why the popup can close itself right after
  // writing and this tab still reliably sees it. Filters to only the one
  // key gmail-auth-result.component.ts writes.
  private handleGmailAuthStorageEvent = (event: StorageEvent): void => {
    if (event.key !== 'finance_mutual_admin_storage') {
      return;
    }
    const result = this._local.customGetItem('gmail_auth_popup_result');
    if (!result) {
      return;
    }
    this._local.customRemoveItem('gmail_auth_popup_result');
    // Native browser event, outside Angular's zone -- without this, the
    // modal closing / toast showing / gmailConnected flag flipping
    // wouldn't trigger change detection until some unrelated interaction.
    this.ngZone.run(() => this.applyGmailAuthResult(result));
  };

  // Only called once the backend confirms the account is actually
  // connected (handleGmailConnectResult) — never from a user dismiss
  // action, since there isn't one.
  private closeConnectGmailModal() {
    this.gmailConnectModalRef?.hide();
    this.enableInspect();
  }

  openModalRestrictedModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template, {
      class: 'restrict__modal modal-dialog-centered',
      backdrop: 'static',
    });
      let doc:any = document.getElementsByClassName('modal');
    doc[0].className = 'modal background-blur';
  }

  disableInspect() {
    document.addEventListener("contextmenu", this.preventRightClick);
    document.addEventListener("keydown", this.preventShortcuts);
  }
  enableInspect() {
    document.removeEventListener("contextmenu", this.preventRightClick);
    document.removeEventListener("keydown", this.preventShortcuts);
  }
  preventRightClick = (e: Event) => {
    e.preventDefault();
  }

  preventShortcuts = (e: KeyboardEvent) => {
    if (
      e.key === "F12" ||
      e.key === "Escape" ||
      (e.ctrlKey && e.shiftKey && ["I", "J", "C"].includes(e.key.toUpperCase())) ||
      (e.ctrlKey && e.key.toUpperCase() === "U")
    ) {
      e.preventDefault();
      e.stopPropagation();
    }
  }
  proceedToLogin() {
    localStorage.setItem('is_restricted', '1');
    this.modalRef.hide();
    let doc:any = document.getElementsByClassName('modal');
    doc[0].className = 'modal';
    this.enableInspect()
    this.maybeShowGmailConnectModal();
  }
  markRead(id:any, index:any){
    let params: any = {};
    if(id){
      params['an_id'] = id;
    }
    this._api.api(params,'user/read_admin_notifications', "post")
    .subscribe((data:any)=>{
        if (this.notifications[index]) {
          this.notifications[index].read_at = `${new Date()}`;
          this.unread_count--;
          this.notification_count--;
          this._shared.setNotificationCount(this.notification_count);
        }
    },(error:any)=>{
        console.log(error);
      })
  }

  redirectToNotification(notification: Notification, index: number){
    this.isCollapsed = true;
    this.isSalesDrawerOpen = false;
    const meta_data = this.parseNotificationMetadata(notification.metadata);
    const reqid =(meta_data  && meta_data.req_id ?  meta_data.req_id : notification.req_id) || meta_data?.training_id || meta_data?.request_id;

    if (!notification.read_at) {
      this.markRead(notification.an_id, index);
    }

    if (this.shouldRedirectNotificationToLead(notification, meta_data)) {
      this.router.navigate(['/app/sales/my-leads-details'], {
        queryParams: {
          lead_id: meta_data.lead_id,
          admin_id: this.admin_profile?.admin_id,
          doctor_id : meta_data.doctor_id
        }
      });
      return;
    }

    const redirect_route = meta_data?.training_id ? '/app/training/details' : notification.notification_type == 112 ? '/app/contracts/disputed' : '/app/assignments/my-assignments';
    if (notification.notification_type != 112) {
      this.router.navigate(
        [redirect_route, reqid] );
    }else{
      this.router.navigate([redirect_route])
    }
  }

  viewMore(){
    this.isCollapsed = true;
    this.isSalesDrawerOpen = false;
    this.router.navigate(['/app/notifications']);
  }

  showNotificationViewAll(): boolean {
    return !this._permissions.salesPermissionFlags.canSeeNotifications;
  }

  private shouldRedirectNotificationToLead(notification: Notification, metadata: any): boolean {
    return this._permissions.salesPermissionFlags.canSeeNotifications &&
      notification.notification_type === 50 &&
      !!metadata?.lead_id;
  }

  private parseNotificationMetadata(metadata: any): any {
    if (!metadata) {
      return {};
    }

    if (typeof metadata !== 'string') {
      return metadata;
    }

    try {
      return JSON.parse(metadata);
    } catch (error) {
      console.log(error);
      return {};
    }
  }

  getRoles() {
    this._api.api({}, 'user/admin_role_list','get')
      .subscribe((data: any) => {
        this._users = data.data;
        const result = this._users?.find((item: { role_id: any; }) => item?.role_id === this.admin_profile?.role_id);
        this.role = result?.role_name;
      });
  }

  toggleDrawer() {
    this.isCollapsed = !this.isCollapsed;
    if (!this.isCollapsed) {
      this.isSalesDrawerOpen = false;
      // Drawer just rendered (*ngIf) — if the loaded page doesn't fill it,
      // fetch more so the list becomes scrollable.
      this.fillNotificationListIfNotScrollable();
    }
  }

  toggleSalesDrawer() {
    this.isSalesDrawerOpen = !this.isSalesDrawerOpen;
    if (this.isSalesDrawerOpen) {
      this.isCollapsed = true;
      this.communicationNotificationCount = 0;
      this.getCommunicationCenterData();
    }else{
    }
  }

  setSalesActiveTab(tab: string) {
    this.salesActiveTab = tab;
    
    if (tab === 'emails') this.emailNotificationCount = 0;
    if (tab === 'messages') this.smsNotificationCount = 0;
    if (tab === 'calls') this.callNotificationCount = 0;

    this.updateFilteredLogs();
  }

  setMappedFilter(filter: 'all' | 'mapped' | 'unmapped') {
    this.commCenterMappedFilter = filter;

    if (filter === 'mapped') {
      if (this.salesActiveTab === 'emails') this.mappedEmailNotificationCount = 0;
      if (this.salesActiveTab === 'messages') this.mappedSmsNotificationCount = 0;
      if (this.salesActiveTab === 'calls') this.mappedCallNotificationCount = 0;
    } else if (filter === 'unmapped') {
      if (this.salesActiveTab === 'emails') this.unmappedEmailNotificationCount = 0;
      if (this.salesActiveTab === 'messages') this.unmappedSmsNotificationCount = 0;
      if (this.salesActiveTab === 'calls') this.unmappedCallNotificationCount = 0;
    } else if (filter === 'all') {
      if (this.salesActiveTab === 'emails') {
        this.mappedEmailNotificationCount = 0;
        this.unmappedEmailNotificationCount = 0;
      }
      if (this.salesActiveTab === 'messages') {
        this.mappedSmsNotificationCount = 0;
        this.unmappedSmsNotificationCount = 0;
      }
      if (this.salesActiveTab === 'calls') {
        this.mappedCallNotificationCount = 0;
        this.unmappedCallNotificationCount = 0;
      }
    }

    this.updateFilteredLogs();
  }

  updateFilteredLogs() {
    this.filteredCommunicationLogs = this.getFilteredLogs(this.salesActiveTab);
  }

  private normalizeCallStatus(status: any): string {
    const normalized = String(status || '')
      .trim()
      .toLowerCase()
      .replace(/[\s-]+/g, '_');

    if (!normalized) {
      return 'pending';
    }

    const statusAliases: Record<string, string> = {
      no_answer: 'not_answered',
      missed_call: 'missed',
      voicemailfull: 'voicemail_full',
      calllater: 'call_later',
      inprogress: 'in_progress',
    };

    return statusAliases[normalized] || normalized;
  }

  getCallStatus(call: any): string {
    return this.normalizeCallStatus(call.status || call.call_status || '');
  }

  getCallStatusLabel(call: any): string {
    const statusKey = this.getCallStatus(call);
    const statusLabels: Record<string, string> = {
      answered: 'Answered',
      completed: 'Completed',
      connected: 'Connected',
      voicemail: 'Voicemail',
      voicemail_full: 'Voicemail Full',
      not_answered: 'Not Answered',
      missed: 'Missed',
      pending: 'Pending',
      call_later: 'Call Later',
      in_progress: 'In Progress',
      ringing: 'Ringing',
      busy: 'Busy',
      failed: 'Failed',
      canceled: 'Canceled',
      cancelled: 'Cancelled',
      disconnected: 'Disconnected',
    };

    if (statusLabels[statusKey]) {
      return statusLabels[statusKey];
    }

    return statusKey
      .split('_')
      .filter(Boolean)
      .map(part => part.charAt(0).toUpperCase() + part.slice(1))
      .join(' ');
  }

  getCallStatusClass(call: any): string {
    const statusKey = this.getCallStatus(call);

    switch (statusKey) {
      case 'answered':
      case 'completed':
      case 'connected':
        return 'status-success';
      case 'voicemail':
      case 'voicemail_full':
      case 'ringing':
      case 'in_progress':
        return 'status-info';
      case 'not_answered':
      case 'missed':
      case 'busy':
      case 'failed':
        return 'status-danger';
      case 'pending':
      case 'call_later':
        return 'status-warning';
      default:
        return 'status-neutral';
    }
  }

  getFilteredLogs(tab: string) {
    if (!this.communication_data) return [];
    
    const filtered = this.communication_data.filter((log: any) => {
      const type = String(log.type || log.log_type || log.communication_type || '').toLowerCase();
      
      // Filter by communication type
      let typeMatch = false;
      if (tab === 'emails') typeMatch = type.includes('email');
      if (tab === 'messages') typeMatch = type.includes('sms') || type.includes('message');
      if (tab === 'calls') typeMatch = type.includes('call') || type.includes('phone') || type.includes('ringcentral');
      
      if (!typeMatch) return false;
      
      // Filter by mapped/unmapped status based on lead_id
      if (this.commCenterMappedFilter === 'mapped') {
        return log.lead_id;
      } else if (this.commCenterMappedFilter === 'unmapped') {
        return !log.lead_id;
      }
      
      // Default 'all' filter - show all
      return true;
    });

    const getLeadContact = (item: any, currentTab: string) => {
        const isOutbound = item.direction && (String(item.direction).toUpperCase() === 'OUTBOUND');
        if (currentTab === 'emails') {
            return (isOutbound ? item.to_email : item.from_email) || item.contact || item.to_email || item.from_email;
        } else {
            return (isOutbound ? item.to_number : item.from_number) || item.contact || item.to_number || item.from_number;
        }
    };

    const groupedLogs: any[] = [];
    const groupMap = new Map<string, any>();

    for (const log of filtered) {
      const contactKey = getLeadContact(log, tab);
      const groupKey = tab === 'calls' && contactKey
        ? `${contactKey}__${this.getCallStatus(log)}`
        : contactKey;
      
      if (log.lead_id && groupKey) {
        if (!groupMap.has(groupKey)) {
          const clonedLog = { ...log, logs_count: 1, grouped_logs: [log], all_lead_ids: new Map([[log.lead_id, log.assigned_to]]), isStatusHeader: false };
          groupMap.set(groupKey, clonedLog);
          groupedLogs.push(clonedLog);
        } else {
          const existing = groupMap.get(groupKey);
          existing.logs_count += 1;
          existing.grouped_logs.push(log);
          existing.all_lead_ids.set(log.lead_id, log.assigned_to);
          
          const existingDate = new Date(existing.created || existing.created_at || 0).getTime();
          const currentDate = new Date(log.created || log.created_at || 0).getTime();
          if (currentDate > existingDate) {
              Object.assign(existing, log, {
                  logs_count: existing.logs_count,
                  grouped_logs: existing.grouped_logs,
                  all_lead_ids: existing.all_lead_ids,
                  isStatusHeader: false
              });
          }
        }
      } else {
        const clonedLog = { ...log, logs_count: 1, grouped_logs: [log], all_lead_ids: new Map(log.lead_id ? [[log.lead_id, log.assigned_to]] : []), isStatusHeader: false };
        groupedLogs.push(clonedLog);
      }
    }

    groupedLogs.forEach(log => {
       log.all_lead_ids_array = (Array.from(log.all_lead_ids.entries()) as [any, any][]).map(([lead_id, assigned_to]) => ({ lead_id, assigned_to }));
    });

    groupedLogs.sort((a, b) => {
       const dateA = new Date(a.created || a.created_at || 0).getTime();
       const dateB = new Date(b.created || b.created_at || 0).getTime();
       return dateB - dateA;
    });

    return groupedLogs;
  }

  redirectToLead(item: any) {
    if (item && item.lead_id) {
      if (this.isSalesDrawerOpen) {
        this.toggleSalesDrawer();
      }
      this._router.navigate(['/app/sales/my-leads-details'], { queryParams: { lead_id: item.lead_id, admin_id: item.assigned_to }});
    }
  }

  redirectToSpecificLead(lead: any, event: Event) {
    event.stopPropagation();
    if (lead && lead.lead_id) {
      if (this.isSalesDrawerOpen) {
        this.toggleSalesDrawer();
      }
      this._router.navigate(['/app/sales/my-leads-details'], { queryParams: { lead_id: lead.lead_id, admin_id: lead.assigned_to }});
    }
  }

  selectedCommunicationItem: any = null;
  selectedCommunicationContent: string = '';

  getCommunicationContent(item: any): string {
    return item?.content || item?.message_body || item?.message || '';
  }

  getGroupedLogs(item: any): any[] {
    return Array.isArray(item?.grouped_logs) && item.grouped_logs.length ? item.grouped_logs : [item];
  }

  openCommunicationContentModal(template: TemplateRef<any>, item: any, event: Event) {
    event.stopPropagation();
    this.selectedCommunicationItem = item;
    this.selectedCommunicationContent = this.getCommunicationContent(item) || 'No content available.';
    this.modalRef = this.modalService.show(template, {
      class: 'modal-dialog-centered modal-lg modal-dialog-scrollable',
      backdrop: 'static',
    });
  }

  toggleChange() {
    this.isDummy = !this.isDummy;
    this.updateQueryParams();
  }

  changeCountry(country: any) {
    if (country){
      this.selectedCountry = country;
      this._shared.mask = country.country_phone_format;
      this.updateQueryParams();
    }
  }

  changeTimezone(timezone: any) {
    this.selectedTimezone = timezone;
    this._shared.allTimezoneData$.next(this.selectedTimezone);
    this._shared.timezone = timezone['val'];
    this._shared.timezoneName = timezone['name'];
    this._shared.timezoneName$.next(timezone['name']);
    this._shared.zone$.next(timezone['zone'] || timezone['offset'] || '');
    this.updateQueryParams();
    this.fetchLatesTask();
  }

  toggleMenu(selectedTap: any, activeParent?: any) {
    if (selectedTap.submenu && selectedTap.submenu.length > 0) {
      selectedTap.isOpen = !selectedTap.isOpen;
    } else {
      selectedTap.isOpen = true;
      if (selectedTap.path == '/app/contracts/list') {
        this._router.navigate([selectedTap.path], {
          queryParams: { type: 1, page: 0, statusFilter: 1, search: '' },
          queryParamsHandling: 'merge',
        });
      } else {
      }
      this._router.navigate([selectedTap.path]);

      setTimeout(() => {
        if (this._router.url.includes(selectedTap.path)) {
          this.selectedSubMenu = selectedTap;
          this.selectedParentMenu = activeParent;
        } else {
          this.selectedSubMenu = null;
          this.selectedParentMenu = null;
        }
      }, 100);
    }

    this.menuList.forEach((menu: any) => {
      if (menu === selectedTap) {
        menu.isOpen = !!selectedTap.isOpen;
      } else {
        menu.isOpen = menu.path == activeParent?.path ? true : false;
      }
    });
  }

  private updateSalesRoute(url: string): void {
    const wasSales = this.isSalesRoute;
    this.isSalesRoute = url.includes('/sales');

    // Start / stop the device-toast loop when entering / leaving sales
    if (this.isSalesRoute && !wasSales) {
      this.detectDevices().then(() => this.startDeviceToastLoop());
      this.checkPermissions();
    } else if (!this.isSalesRoute && wasSales) {
      this.stopDeviceToastLoop();
      this.showPermissionBanner = false;
      this.showDevicePanel = false;
    }
  }

  openNavMenu() {
    const sidenav = document.getElementById('mySidenav');
    if (sidenav) {
      sidenav.style.transform = 'translate(0%)';
    }
  }

  closeNavMenu() {
    const sidenav = document.getElementById('mySidenav');
    if (sidenav) {
      sidenav.style.transform = 'translate(-100%)';
    }
  }

  showLogoutModal() {
    const modelRef = this.modalService.show(ConfirmationModalComponent, {
      initialState: {
        extra_data: {
          label: 'Are you sure you want to Logout ?',
          hideNotes: true
        }
      },
      class : 'modal-dialog-centered',
    })
    modelRef.content?.passEntry.subscribe(response => {
      if (response.success) {
        this._local.customClearAllItems();
        localStorage.removeItem('is_restricted');
        this._router.navigate(['login']);
        // let data = {
        //   admin_id: user.admin_id
        // };
        // this._api.api(data, 'send_credentials_to_admin').subscribe((data: any) => { 
        //   console.log(data); 
        // });
      }
    })
  }

  // Method to add or update the query parameters
  updateQueryParams(): void {
    const existingQueryParams = { ...this.route.snapshot.queryParams };
    const timezoneVal =
      (this.selectedTimezone && this.selectedTimezone['val']) ||
      existingQueryParams['timezone'] ||
      this._local.customGetItem('timezone') ||
      '+530';

    this._local.customSetItem('is_dummy', this.isDummy ? '1' : '0');
    this._local.customSetItem('country_id', (this.selectedCountry && this.selectedCountry.country_id) || 1);
    this._local.customSetItem('timezone', timezoneVal);
    // Get the existing query params from the current route
    const queryParams = existingQueryParams;

    // Update the dummy and country_selected parameters
    queryParams['is_dummy'] = this.isDummy ? 1 : 0;
    queryParams['country_id'] = (this.selectedCountry && this.selectedCountry.country_id) || '1';
    queryParams['timezone'] = timezoneVal;

    // Use router to update the query params without reloading the page
    this._router.navigate([], {
      relativeTo: this.route,
      queryParams: queryParams,
      queryParamsHandling: 'merge',  // Merge with existing query params
      replaceUrl: true               // Replace URL in history without adding a new entry
    });
  }

  getNotifications(){
    if (this.isLoading) {
      return;
    }

    let params: any = { limit: this.notificationPageSize, offset: 0 };

    this.isLoading = true;
    this._api.api(params, 'user/fetch_admin_notifications', 'get')
      .subscribe({
        next: (data: any) => {
          this.isLoading = false;
          if (data && data.is_error == 0) {
            this.notifications = this.decorateNotifications(data.data);
            this.notificationWindowStart = 0;
            this.unread_count = data.unread_count || 0;
            // Sync the local tally BEFORE publishing so our own publish can
            // never satisfy the subscription's "count increased" guard —
            // otherwise fetch → publish → fetch loops forever.
            this.notification_count = data.unread_count || 0;
            this._shared.setNotificationCount(data.unread_count || 0);
            this.count = data.total_count ?? data.count ?? 0;
            // A short first page means there is nothing more to fetch,
            // whatever total_count claims (see fetchNotificationPage).
            if (this.notifications.length < this.notificationPageSize) {
              this.count = this.notifications.length;
            }
            this.fillNotificationListIfNotScrollable();
          }
        },
        error: () => {
          this.isLoading = false;
        }
      })
  }

  // Windowed paging: only notificationMaxWindowPages pages stay in memory.
  // Scrolling down slides the window forward (drop from top), scrolling up
  // slides it back (drop from bottom) and re-fetches earlier pages.
  private fetchNotificationPage(direction: 'down' | 'up') {
    const pageSize = this.notificationPageSize;
    const offset = direction === 'down'
      ? this.notificationWindowStart + this.notifications.length
      : Math.max(0, this.notificationWindowStart - pageSize);

    if (direction === 'down' && offset >= this.count) {
      return;
    }

    this.isLoading = true;
    this._api.api({ limit: pageSize, offset }, 'user/fetch_admin_notifications', 'get')
      .subscribe({
        next: (data: any) => {
          this.isLoading = false;
          if (!data || data.is_error != 0) {
            return;
          }

          const decorated = this.decorateNotifications(data.data);
          this.count = data.total_count ?? data.count ?? this.count;

          // A short/empty page means the server has no more data below,
          // whatever total_count claims — clamp count so the "has more"
          // checks stop retrying the same offset forever.
          if (direction === 'down' && decorated.length < pageSize) {
            this.count = offset + decorated.length;
          }
          if (!decorated.length) {
            return;
          }

          const maxItems = this.notificationPageSize * this.notificationMaxWindowPages;
          const el = this.notificationListRef?.nativeElement;
          const prevScrollHeight = el?.scrollHeight ?? 0;

          if (direction === 'down') {
            let next = [...this.notifications, ...decorated];
            if (next.length > maxItems) {
              const dropCount = next.length - maxItems;
              next = next.slice(dropCount);
              this.notificationWindowStart += dropCount;
              // Dropping items above the viewport shrinks scrollHeight; pull
              // scrollTop back by the removed height so the view doesn't jump.
              if (el) {
                setTimeout(() => {
                  el.scrollTop -= prevScrollHeight - el.scrollHeight;
                });
              }
            }
            this.notifications = next;
          } else {
            this.notificationWindowStart = offset;
            let next = [...decorated, ...this.notifications];
            if (next.length > maxItems) {
              next = next.slice(0, maxItems);
            }
            this.notifications = next;
            // Prepending grows scrollHeight above the viewport; push scrollTop
            // down by the added height so the visible items stay put.
            if (el) {
              setTimeout(() => {
                el.scrollTop += el.scrollHeight - prevScrollHeight;
              });
            }
          }

          this.fillNotificationListIfNotScrollable();
        },
        error: () => {
          this.isLoading = false;
        }
      })
  }

  private canPaginateNotifications(): boolean {
    return this._permissions.salesPermissionFlags.canSeeNotifications && !this.isLoading;
  }

  // If the first page(s) don't fill the drawer there is no scrollbar, so a
  // scroll event can never fire — keep fetching until the list overflows.
  private fillNotificationListIfNotScrollable() {
    if (!this.canPaginateNotifications()
      || this.notificationWindowStart + this.notifications.length >= this.count) {
      return;
    }

    setTimeout(() => {
      const el = this.notificationListRef?.nativeElement;
      if (el && el.scrollHeight <= el.clientHeight && this.canPaginateNotifications()) {
        this.fetchNotificationPage('down');
      }
    });
  }

  // Infinite scroll for sales roles (canSeeNotifications): near the bottom
  // fetch the next page; near the top re-fetch earlier pages that were
  // dropped out of the window. Others use the "View All" page.
  onNotificationScroll(event: Event) {
    if (!this.canPaginateNotifications()) {
      return;
    }

    const el = event.target as HTMLElement;

    if (el.scrollTop + el.clientHeight >= el.scrollHeight - 50
      && this.notificationWindowStart + this.notifications.length < this.count) {
      this.fetchNotificationPage('down');
      return;
    }

    if (el.scrollTop <= 50 && this.notificationWindowStart > 0) {
      this.fetchNotificationPage('up');
    }
  }

  // Mark All as Read button logic
  markAllAsRead() {
    this._api.api({}, 'user/mark_all_notifications_read', 'post').subscribe(
      (data: any) => {
        if (data && data.is_error === 0) {
          // Update read state locally instead of refetching — a refetch would
          // reset the scroll window (and is skipped anyway if a page fetch is
          // in flight due to the isLoading guard).
          const readAt = `${new Date()}`;
          this.notifications.forEach(n => {
            if (!n.read_at) {
              n.read_at = readAt;
            }
          });
          this.unread_count = 0;
          this._shared.setNotificationCount(data.unread_count || 0);
        }
      },
      (error) => {
        console.error('Error marking notifications as read:', error);
      }
    );
  }
  fetchLatesTask() {
    if (!this.selectedTimezone?.zone) {
      return;
    }
    const params : any= {
      timezone: this.selectedTimezone?.zone
    }
    if(this.salesView.dashboardView === 'my'){
      params.selected_admin_id = this.salesView.effectiveSelectedAdminId
    }
    this._api.api(params, 'sales/get_latest_task', 'get').subscribe((data: any) => {
      if (data && data.is_error === 0) {

        this.latestTask = data.result;
        this.startTaskCountdown();
        this._shared.callLatestTask.next(false);
      }
    }
    );
  }

  startTaskCountdown() {
    if (this.taskInterval) {
      clearInterval(this.taskInterval);
      this.taskInterval = null; 
    }

    this.updateTaskCountdown();
    this.taskInterval = setInterval(() => {
      this.updateTaskCountdown();
    }, 1000);
  }

  private decorateNotifications(notifications: any[]): any[] {
    
    if (!notifications || !notifications.length) {
      return notifications;
    }
    if (this._permissions.salesPermissionFlags.canSeeNotifications) {
      notifications = notifications.filter(
        (notification: any) => notification?.notification_type === 50 || notification?.notification_type === '50'
      );
    }
    return notifications.map((notification: any) => {
      if (notification?.notification_type === 50) {
        const meta_data = this.parseNotificationMetadata(notification.metadata);
         console.log(meta_data)
        const additional_text = meta_data?.additional_text;
        if (additional_text) {
          notification.message = notification.message
            ? `${notification.message.replace(/\.$/, '')}. ${additional_text}`
            : additional_text;
        }
      }
      return notification;
    });
  }
  updateTaskCountdown() {
    const date_time = this.latestTask?.demo_time ? this.latestTask?.demo_time : this.latestTask.date_time;
    if (!date_time) {
      this.taskCountdown = '';
      this.remainingMs = 0;
      return;
    }
    // console.log(this.remainingMs)
    const timezone = this.selectedTimezone?.zone; // e.g. "America/Los_Angeles"

    // 🚀 Treat API time as panel timezone (NOT real UTC)
    const demoTime = moment.tz(
      date_time.replace('Z', ''),
      timezone
    ).valueOf();

    const now = moment.tz(timezone).valueOf();
    const distance = demoTime - now;
    this.remainingMs = distance;
  
    if (distance <= 0) {
      this.taskCountdown = '';
      return;
    }
  
    const duration = moment.duration(distance);

    const hours = Math.floor(duration.asHours());
    const minutes = duration.minutes();
    const seconds = duration.seconds();
  
    this.taskCountdown =
      (hours > 0 ? `${hours}h ` : '') +
      `${minutes} mins ${seconds} secs`;
  }
  getCommunicationCenterData() {
    this._api.api({}, 'leads/get_communication_logs_notification', 'get').subscribe((data: any) => {
      if (data && data.is_error === 0) {
        const mappedLogs = data.data?.mapped_logs || [];
        const unmappedLogs = data.data?.unmapped_logs || [];
        
        let combinedLogs = [...mappedLogs, ...unmappedLogs];
        
        combinedLogs.sort((a: any, b: any) => {
          const dateA = new Date(a.created || a.created_at || 0).getTime();
          const dateB = new Date(b.created || b.created_at || 0).getTime();
          return dateB - dateA;
        });

        this.communication_data = combinedLogs;
        this.updateFilteredLogs();
      }
    });

  }

  getTimeAgo(dateString: string): string {
    if (!dateString) return '';
    return moment(dateString).fromNow();
  }

  getAttachments(item: any): string[] {
    if (!item) return [];
    let attachments: any = item.attachments || item.attachment || item.attachment_url;
    if (!attachments) return [];
    
    if (typeof attachments === 'string') {
      try {
        const parsed = JSON.parse(attachments);
        if (Array.isArray(parsed)) {
          return parsed.map(att => typeof att === 'string' ? att : (att.url || att.file_url || att.attachment_url || att));
        }
      } catch (e) {
        // If it's a direct URL string
        if (attachments.startsWith('http')) {
          return [attachments];
        }
      }
    } else if (Array.isArray(attachments)) {
      return attachments.map(att => typeof att === 'string' ? att : (att.url || att.file_url || att.attachment_url || att));
    }
    
    return [];
  }

  removeCommAlert(id: number) {
    this.activeCommAlerts = this.activeCommAlerts.filter(a => a.id !== id);
  }

  ngOnDestroy() {
    window.removeEventListener('storage', this.handleGmailAuthStorageEvent);
    if (this.taskInterval) {
      clearInterval(this.taskInterval);
    }
    this.stopDeviceToastLoop();
    this.sub.unsubscribe();
    if (navigator.mediaDevices?.removeEventListener) {
      navigator.mediaDevices.removeEventListener('devicechange', this.deviceChangeHandler);
    }
  }
}


export interface Notification {
  an_id: number;
  admin_id: number;
  from_type: string;
  from_id: number;
  contract_id: number;
  notification_type: number;
  title: string;
  message: string;
  metadata: string;
  req_id: string;
  action: string;
  read_at: string | null;
  sent_at: string;
  is_deleted: number;
  admin_name: string;
}
